import gilixApi from './gilix.api';

const BAVYROX_FORM_ID = 2;

export async function handleBavyroxQuizz(params: { email?: string; fullName?: string; [key: string]: any }) {
    const mauticData = {
        mauticform: {
            formId: BAVYROX_FORM_ID,
            email: params.email,
            f_name: params.fullName,
            return: '',
        }
    };

    const res = await gilixApi.post(
        `/form/submit?formId=${BAVYROX_FORM_ID}`,
        new URLSearchParams(flattenObject(mauticData)).toString()
    );
    return res.data;
}

function flattenObject(obj: any, prefix = ''): Record<string, string> {
    const result: Record<string, string> = {};
    for (const key of Object.keys(obj)) {
        const newKey = prefix ? `${prefix}[${key}]` : key;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            Object.assign(result, flattenObject(obj[key], newKey));
        } else {
            result[newKey] = String(obj[key] ?? '');
        }
    }
    return result;
}
